<template>
<div>
  <DataNavigation></DataNavigation>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">招标采购
          </p>
          <!-- <Dropdown trigger="hover" class="change_type" placement="bottom-start" @on-visible-change="handleDropdown2" @on-click="handleChangeListType">
            <p class="top-tip">采购信息<Icon type="md-arrow-dropup" v-if="drop_val2" /><Icon type="md-arrow-dropdown" v-if="!drop_val2" /></p>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(item, index) in list_type" :name="item.id" :selected="active_type == item.id" :key="index">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown> -->
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '项目标签'">
                <div class="screen_tle" @click="screenTle.bidding_tag = !screenTle.bidding_tag">
                  <span>项目标签</span>
                  <Icon type="md-add" v-if="!screenTle.bidding_tag" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.bidding_tag">
                    <ul class="scr_attention">
                        <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                        <li v-for="tItem in bidding_type" :key="tItem.id" v-if="tItem.pid==null">
                            <div class="scr_att_tle" :class="{'underline':tItem.id != '1'}">
                              <div v-if="tItem.id != '1'">
                                <Icon type="md-arrow-dropright" />
                                <span>{{tItem.name}}</span>
                                <i class="iconfont" v-if="tItem.id != '1'">&#xe738;</i>
                              </div>
                              <div v-else>
                                <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                                <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                                <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                              </div>
                            </div>
                            <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                              <Checkbox v-for="item in bidding_type" :label="item.id" :key="item.id" v-if="item.pid === tItem.id">
                                  <span>{{item.name}}</span>
                              </Checkbox>
                            </div>
                        </li>
                        </CheckboxGroup>
                    </ul>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '公告时间'">
                <div class="screen_tle" @click="screenTle.quarter = !screenTle.quarter">
                  <span>公告时间</span>
                  <Icon type="md-add" v-if="!screenTle.quarter" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.quarter">
                  <RadioGroup v-model="selTime" vertical @on-change="handleChangeQuarter">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio label="1"><span>本季度</span></Radio>
                    <Radio label="2"><span>上季度</span></Radio>
                    <Radio label="zdy"><span>自定义</span></Radio>
                  </RadioGroup>
                  <div class="zdy_time" v-if="selTime == 'zdy'">
                    <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                  </div>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '中标金额'">
                <div class="screen_tle" @click="screenTle.bidding_amount = !screenTle.bidding_amount">
                    <span>中标金额</span>
                    <Icon type="md-add" v-if="!screenTle.bidding_amount" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.bidding_amount">
                    <RadioGroup v-model="params.bidding_amount" vertical @on-change="clearGetList">
                        <Radio :label="null"><span>不限</span></Radio>
                        <Radio v-for="item,index in bidding_amount_arr" :label="item.id" :key="index"><span>{{item.name}}</span></Radio>
                    </RadioGroup>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '采购地点'">
                <div class="screen_tle" @click="screenTle.province = !screenTle.province">
                    <span>采购地点</span>
                    <Icon type="md-add" v-if="!screenTle.province" />
                    <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.province">
                    <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                    <span>全部</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                        <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                        </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAllAddress = !showAllAddress">
                    <template v-if="!showAllAddress">查看更多</template>
                    <template v-else>收起更多</template>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP && listData.length == 5 && total > 5"></SearchPrompt>
          <template v-else>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
          </template>
          <!-- <Page :total="total" :page-size="2" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" /> -->
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  biddingList,
  getMeta
} from '../../service'
import {
  remove
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    DataNavigation,
    VipPrompt,
    SearchPrompt
  },
  data() {
    return {
      listName: '招标',
      // list_type: [
      //   {id: 1, name: '采购信息'},
      //   {id: 2, name: '中标数据'}
      // ],
      // drop_val2: false,
      // active_type: 1,
      listColumns: [{
          title: '中标项目名称',
          width: 239,
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.goBiddingDetail(params.row.id)
                }
              },
              class: {
                'dec-clamp': true
              }
            }, params.row.project_ele_name)
          }
        },
        {
          title: '采购单位',
          width: 160,
          render: (h, params) => {
            return (
                (params.row.project_entity_short_name 
                && (params.row.project_entity_type === '0'
                || params.row.project_entity_type === '1'
                || params.row.project_entity_type === '2'
                || params.row.project_entity_type === '3'))?h('a', {
                on: {
                    click: () => {
                    this.goEntityDetail(params.row.entity_uid, params.row.project_entity_type, { active_name: 'buy' })
                    }
                },
                class: {
                    'dec-clamp': true
                }
                }, params.row.project_entity_short_name):h('span', params.row.dw_name)
            )
          }
        },
        {
          title: '采购地区',
          width: 106,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          }
        },
        {
          title: '项目标签',
          width: 110,
          render: (h, params) => {
            let temp_str = ''
            for(let i = 0;i < params.row.project_ele_type.length; i++) {
              if(i == 0) {
                temp_str += filter.dealName(params.row.project_ele_type[i], this.bidding_type)
              } else {
                temp_str = temp_str+'、'+filter.dealName(params.row.project_ele_type[i], this.bidding_type)
              }
            }
            return h('span', temp_str)
          }
        },
        {
          title: '中标金额',
          width: 134,
          render: (h, params) => {
            return h('span', params.row.winning_bid_amount?parseFloat(params.row.winning_bid_amount)+'万人民币':'未透露')
          }
        },
        {
          title: '中标单位',
          width: 110,
          render: (h, params) => {
            if(params.row.winning_entity.length != 0) {
              let temp_arr = []
              for(let i = 0;i < params.row.winning_entity.length; i++) {
                  if(params.row.winning_entity[i].winning_bid_entity_type == '0'
                  ||params.row.winning_entity[i].winning_bid_entity_type == '1'
                  ||params.row.winning_entity[i].winning_bid_entity_type == '2'
                  ||params.row.winning_entity[i].winning_bid_entity_type == '3'){
                      temp_arr.push(h('a',{
                      on: {
                          click: () => {
                          this.goEntityDetail(params.row.winning_entity[i].winning_bid_entity_uid, params.row.winning_entity[i].winning_bid_entity_type, { active_name: 'win' })
                          }
                      },
                      class: {
                          'dec-clamp': true
                      }
                      },  i == 0 ? params.row.winning_entity[i].winning_bid_entity_name:'、'+params.row.winning_entity[i].winning_bid_entity_name))
                  } else {
                      temp_arr.push(h('span',
                      i == 0 ? params.row.winning_entity[i].winning_bid_entity_name:'、'+params.row.winning_entity[i].winning_bid_entity_name))
                  }
              }
              return h('div', temp_arr)
            } else {
              return h('span', '--')
            }
          }
        },
        {
          title: '公告时间',
          // width: 100,
          render: (h, params) => {
            return h('span', filter.time_moment(params.row.winning_bid_time,'YYYY-MM-DD'))
          }
        }
      ],
      params: {
        bidding_amount: null,
        address_id: [],
        quarter: '',
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        tag_arr: [],
        keyword: '',
        sort_type: 0
      },
      screen_dropdown: ['全部', '项目标签', '公告时间', '中标金额', '采购地区'],
      bidding_type: [], // 项目标签
      bidding_amount_arr: [
        { id:0, name: "小于50万元" },
        { id:1, name: "50~100万元" },
        { id:2, name: "100~200万元" },
        { id:3, name: "200~500万元" },
        { id:4, name: "500~1000万元" },
        { id:5, name: "大于1000万元" }
      ],
      //筛选条件是否展开
      screenTle: {
        bidding_amount: false,
        quarter: false,
        province: false,
        bidding_tag: false
      },
      //不限
      checkAll: {
        address_id: true
      },
      showAllTag: false,

      sort_id: 0,
      sort_list: [
        {id: 0, name: '公告时间降序'},
        {id: 1, name: '公告时间升序'},
        {id: 2, name: '中标金额降序'},
        {id: 3, name: '中标金额升序'}
      ]

    }
  },
  computed: {
    haveOption() {
      let optionQuarter = [],
        optionTag = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionAmount = []
      this.params.tag_arr.map((a) => {
        optionTag.push({
          type: 'tag_arr',
          name: filter.dealName(a, this.bidding_type),
          value: a
        })
      })
      if (this.params.quarter != '' && this.selTime != 'zdy') {
        optionQuarter = {
          type: 'quarter',
          name: this.params.quarter == '1' ? '本季度':'上季度',
          value: this.params.quarter
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      if (this.params.bidding_amount !== null) {
        optionKeyWord = {
          type: 'bidding_amount',
          name: this.bidding_amount_arr.find(item => item.id == this.params.bidding_amount).name,
          value: this.params.bidding_amount
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a
        })
      })

      return [].concat(
        optionQuarter,
        optionTag,
        optionStart,
        opitonEnd,
        optionAddressId,
        optionKeyWord,
        optionAmount
      )
    }
  },
  methods: {
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await biddingList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
            this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        tag_arr: [],
        quarter: '',
        address_id: [],
        s_time: '',
        e_time: '',
        page: 1,
        user_key: '',
        keyword: '',
        bidding_amount: null
      }
      this.checkAll = {
        address_id: true
      }
      this.search_ipt = ''
      this.selTime = ''
      this.params.page = 1
      this.getEntityList()
    },
    /**
     * 公告时间筛选
     */
    handleChangeQuarter(val) {
      if (!this.listLoading) {
        if (val == '' || val == 'zdy') {
          this.params.quarter = ''
          this.params.s_time = ''
          this.params.e_time = ''
        } else {
          this.params.quarter = val
          this.params.s_time = ''
          this.params.e_time = ''
        }
        this.params.page = 1
        this.getEntityList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 按需获取元数据
     */
    async getMeta() {
      let res = await getMeta({
        name: ['bidding_type']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'bidding_type', res.meta.bidding_type)
      } else {
        this.$Message.error(res.message)
      }
    },
    goBiddingDetail(id) {
        // this.$router.push({name: 'TenderDetail', params: { id: id }})
        const {
          href
        } = this.$router.resolve({
          name: "TenderDetail",
          params: {
            id: id
          }
        })
        window.open(href, '_blank')
    },
    // handleChangeListType(val) {
    //   this.active_type = val
    //   if(val == 2) {
    //     this.$router.push({ name: "DiddingList"})
    //   }
    // }
  },
  created() {
    this.getMeta()
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    // this.$store.commit('updateOrgParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
// .change_type
//   >>> .top-tip
//     cursor pointer
//     .ivu-icon
//       color #999999
//     &:hover
//       color #fa7a50
//       .ivu-icon
//         color #fa7a50
//   >>> .ivu-select-dropdown
//     font-weight normal
//     background-color: #fff
//     box-shadow: 2px 4px 20px 0px rgba(121,133,143,0.2)
//     border-radius: 0
//     .ivu-dropdown-menu
//       width: 130px
//       .ivu-dropdown-item
//         color: #666
//       .ivu-dropdown-item-selected
//       .ivu-dropdown-item.ivu-dropdown-item-selected:hover
//         color: #fa7a50 !important
//         background-color: #f9f9f9
//       .ivu-dropdown-item-selected
//       .ivu-dropdown-item-selected:hover
//         color: #fa7a50 !important
//       .ivu-dropdown-item:hover
//         background-color: #f9f9f9
</style>
